import { Link } from 'react-router-dom';
import { useProblems } from '../hooks/useProblems';
import ProblemCard from '../components/ProblemCard';
import { api } from '../services/api';
import type { Problem } from '@attack100/shared';

function Dashboard() {
  const { problems, loading, error, refetch } = useProblems();

  const handleDeleteProblem = async (problem: Problem) => {
    try {
      await api.deleteProblem(problem.id);
      await refetch();
    } catch (err) {
      console.error('Failed to delete problem:', err);
      alert('Failed to delete problem. Please try again.');
    }
  };

  return (
    <div>
      <header className="header">
        <div className="header-content">
          <Link to="/" className="logo">Attack100</Link>
          <Link to="/problems/new" className="btn btn-primary">
            + New Problem
          </Link>
        </div>
      </header>

      <div className="container">
        <div style={{ marginBottom: '2rem' }}>
          <h1 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '0.5rem' }}>
            Your Problems
          </h1>
          <p style={{ color: 'var(--gray-600)' }}>
            Attack each problem from 100 different angles
          </p>
        </div>

        {error && <div className="error">{error}</div>}

        {loading ? (
          <div className="loading">Loading problems...</div>
        ) : problems.length === 0 ? (
          <div className="empty-state">
            <h3>No problems yet</h3>
            <p>Create your first problem to start attacking it from multiple angles</p>
            <Link to="/problems/new" className="btn btn-primary">
              Create Your First Problem
            </Link>
          </div>
        ) : (
          <div className="grid grid-2">
            {problems.map((problem) => (
              <ProblemCard key={problem.id} problem={problem} onDelete={handleDeleteProblem} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
